import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import useMediaQuery from '@mui/material/useMediaQuery';

interface MichrazInfoCard {
	// _id: Number;
	MichrazName: String;
	// StatusMichraz: Number;
	// KodYeudMichraz: Number;
	// KodYeshuv: Number;
	YechidotDiur: Number;
	Shchuna: String;
	// PirsumDate: Date;
	// PtichaDate: Date;
	SgiraDate: Date;
	// VaadaDate: Date;
	// SiyurDate: Date;
	// KodSugMichraz: Number;
	// UpdateDate: Date;
	// HagashaMekuvenet: Boolean;
	// Location: any;

	YeudMichrazText: String;
	YeshuvText: String;
	SugMichrazText: String;
	// StatusMichrazText: String;
	isSelected: Boolean;
}

export default function OpenOccCard(props: MichrazInfoCard) {
	const {
		isSelected,
		MichrazName,
		YeshuvText,
		SugMichrazText,
		Shchuna,
		YechidotDiur,
		YeudMichrazText,
		SgiraDate
	} = props;

	const theme = useTheme();
	const isDesktop = useMediaQuery('(min-width:600px)');

	return (
		<Card
			sx={{
				cursor: 'pointer',
				background: isSelected ? '#F0FFF0' : null,
				display: 'flex',
				marginLeft: '10px',
				marginRight: isDesktop ? '0px' : '10px',
				marginBottom: '10px',
				// boxShadow: '20px',
				boxShadow:
					'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
				borderLeft: '2px solid #ED1212 ',
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column' }}>
				<CardContent sx={{ flex: '1 0 auto' }}>
					<Typography component="div" variant="h6">
						{MichrazName} |{YeshuvText} |{SugMichrazText} |{Shchuna} |{' '}
						{YechidotDiur} יח”ד
					</Typography>
					<Typography
						variant="subtitle1"
						color="text.secondary"
						component="div"
					>
						{YeudMichrazText} | | מועד אחרון: | {SgiraDate} | (עוד 3
						ימים)
					</Typography>
				</CardContent>
			</Box>
			{/* <CardMedia
				component="img"
				sx={{ width: 151 }}
				image="/static/images/cards/live-from-space.jpg"
				alt="Live from space album cover"
			/> */}
		</Card>
	);
}
